/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * クーポン適用対象者
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable {
    /**
     * クーポン適用対象者No.
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    couponApplicableNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    relationship?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    degreeCount?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable
     */
    ageType?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable {
    return JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'couponApplicableNo': !exists(json, 'couponApplicableNo') ? undefined : json['couponApplicableNo'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'relationship': !exists(json, 'relationship') ? undefined : json['relationship'],
        'degreeCount': !exists(json, 'degreeCount') ? undefined : json['degreeCount'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'ageType': !exists(json, 'ageType') ? undefined : json['ageType'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'couponApplicableNo': value.couponApplicableNo,
        'lastName': value.lastName,
        'firstName': value.firstName,
        'relationship': value.relationship,
        'degreeCount': value.degreeCount,
        'age': value.age,
        'ageType': value.ageType,
    };
}

